<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    :class="extraNavClasses"
    class="md-transparent md-absolute"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <md-button class="md-just-icon md-simple">
          <router-link :to="`/${$i18n.locale}/`">
            <img v-if="logo_type === 'default'" :src="logo" />
            <img v-else-if="logo_type === 'white'" :src="logo_white" />
            <img v-else :src="logo_black" />
          </router-link>
        </md-button>
        <router-link
          class="nav-name"
          v-show="shouldShowName && !isMobileDevice"
          :style="initalTextColorStyle"
          :to="`/${$i18n.locale}/`"
          >{{ $t("nav.name") }}</router-link
        >
      </div>
      <div class="md-toolbar-section-end">
        <md-list>
          <md-list-item
            v-bind:class="{ selected: isSelected[0] }"
            class="nav-item"
          >
            <router-link
              :style="initalTextColorStyle"
              :to="`/${$i18n.locale}/`"
              >{{ $t("nav.work") }}</router-link
            >
          </md-list-item>
          <md-list-item
            v-bind:class="{ selected: isSelected[1] }"
            class="nav-item"
          >
            <router-link
              :style="initalTextColorStyle"
              :to="`/${$i18n.locale}/about`"
              >{{ $t("nav.about") }}</router-link
            >
          </md-list-item>
        </md-list>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
import Vue from "vue";
export default {
  components: {
    // MobileMenu
  },
  props: {
    logo: {
      type: String,
      default: require("@/assets/img/logo.png")
    },
    logo_white: {
      type: String,
      default: require("@/assets/img/logo_white.png")
    },
    logo_black: {
      type: String,
      default: require("@/assets/img/logo_black.png")
    },
    type: {
      type: String,
      default: "white",
      validator(value) {
        return ["white", "black"].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    initalTextColor: {
      type: String,
      default: "black"
    },
    logo_type: {
      type: String,
      default: "default"
    },
    shouldShowName: Boolean
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      extraNavClasses: "",
      extraMobileNavClasses: "",
      toggledClass: false,
      isSelected: [true, false]
    };
  },
  computed: {
    initalTextColorStyle() {
      return {
        color: `${this.initalTextColor} !important`
      };
    }
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale }
      });
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        this.extraMobileNavClasses = `md-collapse-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
  watch: {
    $route: {
      handler: function(to, from) {
        if (to.name === "home") {
          Vue.set(this.isSelected, 0, true);
          Vue.set(this.isSelected, 1, false);
        } else if (to.name === "about") {
          Vue.set(this.isSelected, 0, false);
          Vue.set(this.isSelected, 1, true);
        } else {
          Vue.set(this.isSelected, 0, false);
          Vue.set(this.isSelected, 1, false);
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-item {
  a {
    font-size: 1rem !important;
    font-weight: 400 !important;
  }
}
</style>
